import mainTheme from './Main'

const themes = {
  main: mainTheme,
}

export default themes
